import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/components/Main';
import Metrics from '@/components/Metrics';
import Add from '@/components/Add';
import Testing from '@/components/Testing';
import Charts from '@/components/Charts';
import Pricing from '@/components/Pricing';
import Profile from '@/components/Profile';
import API from '@/components/API';
import About from '@/components/About';
import Batch from '@/components/Batch';
import BatchMain from '@/components/BatchMain';
import BatchAdd from '@/components/BatchAdd';
import BatchDefine from '@/components/BatchDefine';
import BatchEdit from '@/components/BatchEdit';
import BatchDelete from '@/components/BatchDelete';
import Shapes from '@/components/Shapes';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      props: true
    },
    {
      path: '/metrics/:param_collection_id/:collection_type',
      name: 'Metrics',
      component: Metrics,
      props: true
    },
    {
      path: '/metrics/:param_collection_id/:collection_type/:query',
      name: 'Metrics2',
      component: Metrics,
      props: true
    },
    {
      path: '/add',
      name: 'Add',
      component: Add,
      props: true
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      props: true
    },
    {
      path: '/api',
      name: 'API',
      component: API,
      props: true
    },
    {
      path: '/batchadd',
      name: 'BatchAdd',
      component: BatchAdd,
      props: true
    },
    {
      path: '/batchdefine',
      name: 'BatchDefine',
      component: BatchDefine,
      props: true
    },
    {
      path: '/batchedit',
      name: 'BatchEdit',
      component: BatchEdit,
      props: true
    },
    {
      path: '/batchdelete',
      name: 'BatchDelete',
      component: BatchDelete,
      props: true
    },
    {
      path: '/testing',
      name: 'Testing',
      component: Testing,
      props: true
    },
    {
      path: '/charts/:param_collection_id',
      name: 'Charts',
      component: Charts,
      props: true
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
      props: true
    },
    {
      path: '/batch/:batch_id',
      name: 'Batch',
      component: Batch,
      props: true
    },
    {
      path: '/batch/:batch_id/:query',
      name: 'Batch2',
      component: Batch,
      props: true
    },
    {
      path: '/batchhome',
      name: 'BatchHome',
      component: BatchMain,
      props: true
    },
    {
      path: '/shapes',
      name: 'Shapes',
      component: Shapes,
      props: true
    },
    {
      path: '/shapes/:query',
      name: 'Shapes2',
      component: Shapes,
      props: true
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      props: true
    },

    {
      path: '*',
      redirect:"/"
    }
  ]
})
